module.exports = __webpack_public_path__ + "static/media/service-center-spooring-balancing.3cc9262b.jpg";